module.exports = __webpack_public_path__ + "img/usage_whole.d55305d9.png";